export function reorderMinimal(order: string[], highestFirst: readonly string[]): string[] {
  const included = new Set(order)
  const desired = [...new Set(highestFirst)].filter((id) => included.has(id)).reverse()
  const ranks = new Map(desired.map((id, index) => [id, index]))
  const selected = order.filter((id) => ranks.has(id))
  if (selected.every((id, index) => id === desired[index])) {
    return order
  }
  const chains: { id: string; rank: number; length: number; previous?: number }[] = []
  let longest: number | undefined
  for (const id of selected) {
    const rank = ranks.get(id)
    if (rank === undefined) {
      continue
    }
    const node: (typeof chains)[number] = { id, rank, length: 1 }
    for (const [index, previous] of chains.entries()) {
      if (previous.rank < rank && previous.length >= node.length) {
        node.length = previous.length + 1
        node.previous = index
      }
    }
    const best = longest === undefined ? undefined : chains[longest]
    if (!best || node.length > best.length) {
      longest = chains.length
    }
    chains.push(node)
  }
  const kept = new Set<string>()
  while (longest !== undefined) {
    const node = chains[longest]
    if (!node) {
      break
    }
    kept.add(node.id)
    longest = node.previous
  }
  const before = new Map<string, string[]>()
  let pending: string[] = []
  let lastKept: string | undefined
  for (const id of desired) {
    if (kept.has(id)) {
      before.set(id, pending)
      pending = []
      lastKept = id
    } else {
      pending.push(id)
    }
  }
  const result: string[] = []
  for (const id of order) {
    if (ranks.has(id) && !kept.has(id)) {
      continue
    }
    result.push(...(before.get(id) ?? []), id)
    if (id === lastKept) {
      result.push(...pending)
    }
  }
  return result
}
